<modal>
    <p class="has-text-centered">
        <span class="icon-and-text">
            <span class="icon is-small is-rotating"><i class="tri-logo"></i></span>
            <span>Chargement en cours...</span>
        </span>
    </p>
</modal>
